import React, { FC } from 'react';
import { MdCheckCircle, MdError, MdInfo, MdWarning } from 'react-icons/md';
import clsx from 'clsx';
import Button from '@atoms/Button';
import Modal from '@atoms/Modal';
import './MessageModal.scss';
import { IModalMessage } from '@molecules/ModalMessages/IModalMessage';

export interface IMessageModalProp {
    /** Данные уведомление */
    item: IModalMessage;
    /** Закрыть уведомление */
    remove?: (id: number) => void;
}

const MessageModal: FC<IMessageModalProp> = ({ item, remove }: IMessageModalProp) => {
    const onRemove = () => {
        item.id && remove && remove(item.id);
    };
    const onClose = () => {
        item.closeBtnClick && item.closeBtnClick();
        onRemove();
    };

    const getMessageIcon = (type?: string) => {
        switch (type) {
            case 'error':
                return <MdError size="24" />;
            case 'warning':
                return <MdWarning size="24" />;
            case 'success':
                return <MdCheckCircle size="24" />;
            case 'info':
                return <MdInfo size="24" />;
            default:
                return <MdInfo size="24" />;
        }
    };

    const getMessageColorClass = (type?: string) => {
        switch (type) {
            case 'error':
                return 'message-modal__error-color';
            case 'warning':
                return 'message-modal__warning-color';
            case 'success':
                return 'message-modal__success-color';
            case 'info':
                return 'message-modal__info-color';
            default:
                return 'message-modal__default-color';
        }
    };

    const ModalFooter = ({ onClose }: { onClose: () => void }) => (
        <div className={'message-modal__footer'}>
            {item.buttons &&
                item.buttons.map((button, i) => {
                    return (
                        <Button
                            onClick={() => {
                                onRemove();
                                button.onClick();
                            }}
                            key={i}
                            size="s"
                            buttonType={button.buttonType}
                        >
                            {button.title}
                        </Button>
                    );
                })}

            <Button onClick={onClose} size="s" buttonType={item.closeBtnType}>
                {item.closeBtnTitle ? item.closeBtnTitle : 'Ок'}
            </Button>
        </div>
    );

    return (
        <Modal
            size="xl"
            footer={<ModalFooter onClose={onClose} />}
            header={
                <div className={clsx('box')}>
                    <div>
                        <div>{item.title ? item.title : 'Внимание'}</div>
                    </div>
                </div>
            }
        >
            <div className="message-modal__container">
                {item?.message?.length > 0 && Array.isArray(item?.message) ? (
                    item?.message?.map((msg, index) => {
                        return (
                            <div key={index} className="message-modal__row">
                                <div className={clsx('error-Icon', getMessageColorClass(item.type))}>
                                    {getMessageIcon(item.type)}
                                </div>
                                <div
                                    className="message-modal__message"
                                    dangerouslySetInnerHTML={{ __html: msg?.toString() }}
                                />
                            </div>
                        );
                    })
                ) : (
                    <></>
                )}
            </div>
        </Modal>
    );
};

export default MessageModal;
